/* eslint-disable no-param-reassign,default-case,consistent-return */
import Progress from 'redux-progress';
import setWith from 'lodash/setWith';
import clone from 'lodash/clone';
import * as actions from 'modules/checkout/contacts/duck/actions';

export default (state = Progress.none, action) => {
  switch (action.type) {
    case actions.LOAD:
      return action.progress;
    case actions.EDIT:
      return state.map((data) => setWith(clone(data), action.path, action.payload, clone));
    case actions.SUBMIT:
      if (action.progress.success) {
        return Progress.none;
      }
  }
  return state;
};
